module.exports = __webpack_public_path__ + "img/ojfeature4.340f5d0a.jpg";